<template>
  <!-- 广告列表 -->
  <div>
    <!-- 筛选查询 -->
    <div class="wScreenArea">
      <el-card class="box-card">
        <div class="wScreenCardHeader">
          <span></span>
          <el-button type="primary" size="mini" @click="wFun_openAnnouncementFrame()">发布公告</el-button>
        </div>
      </el-card>
    </div>
    <!-- 表格数据 -->
    <div class="wTableArea">
      <!-- 公告列表 -->
      <template>
        <!-- 表格 -->
        <el-table border :data="wTable.wList">
          <el-table-column prop="id" label="编号" align="center" width="100">
          </el-table-column>
          <el-table-column label="公告标题" align="center" prop="title">
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <template slot-scope="scope">
              <el-button type="text" @click="wFun_openAnnouncementFrame(scope)"><span>编辑</span></el-button>
              <el-button type="text" @click="wFun_deleteAnnouncementById(scope.row.id)"><span>删除</span></el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!-- 分页 -->
      <div class="wPagination">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="wTable.wPage"
          :page-size="wTable.wLimit" :total="wTable.wTotal" :page-sizes="[5, 10, 15, 20, 50]"
          :hide-on-single-page="false" @current-change="wELPageCurrentChange" @size-change="wELPageSizeChange">
        </el-pagination>
      </div>
    </div>

    <!-- 新增、修改版announcement弹框 -->
    <el-dialog :title="wAnnouncement.wForm.wId ? '修改公告' : '添加公告'" :visible.sync="wAnnouncement.wIsShow"
      :append-to-body="true" :close-on-click-modal="false">
      <!-- 表单 -->
      <el-form ref="wAnnouncementForm" :model="wAnnouncement.wForm" label-width="120px" @submit.native.prevent>
        <el-form-item label="公告标题：" prop="wTitle" required>
          <el-input v-model="wAnnouncement.wForm.wTitle" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="公告内容：" prop="wContent" required>
          <quill-editor
            ref="announcementEditor"
            v-model="wAnnouncement.wForm.wContent"
            :options="editorOptions"
            class="wAnnouncementEditor"
          />
        </el-form-item>
        <el-form-item label="上传素材：" prop="wUrl" class="wUploadFormItem">
          <el-upload class="wMediaUploader" :action="wFun_getUploadFilePath()" :file-list="wAnnouncement.wMediaFileList"
            :limit="1" :before-upload="wFun_beforeUpload_media" :on-success="wFun_success_media"
            :on-error="wFun_error_media" :on-remove="wFun_remove_media" :on-exceed="wFun_exceed_media"
            :auto-upload="true">
            <el-button size="small" type="primary">上传图片/视频</el-button>
            <div slot="tip" class="el-upload__tip">支持 JPG/PNG/GIF/WEBP、MP4/MOV/WEBM，最多1个文件</div>
          </el-upload>
          <div v-if="wAnnouncement.wForm.wUrl" class="wMediaPreview">
            <el-image v-if="wAnnouncement.wMediaType == 'image'" class="wMediaPreviewImage" fit="contain"
              :src="wAnnouncement.wForm.wUrl" :preview-src-list="[wAnnouncement.wForm.wUrl]"></el-image>
            <video v-else-if="wAnnouncement.wMediaType == 'video'" class="wMediaPreviewVideo"
              :src="wAnnouncement.wForm.wUrl" controls preload="metadata"></video>
            <el-link v-else :href="wAnnouncement.wForm.wUrl" type="primary" target="_blank">打开已上传素材</el-link>
          </div>
        </el-form-item>
      </el-form>
      <!-- footer -->
      <div slot="footer">
        <el-button @click="wAnnouncement.wIsShow = false">取 消</el-button>
        <el-button type="primary" @click="wFun_submitAnnouncementInfo">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  inquiryNotice,
  addOperateAnnouncementApi,
  editOperateAnnouncementApi,
  deleteOperateAnnouncementApi
} from "@/network/api";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  name: "OperateAnnouncement",
  components: {
    quillEditor
  },
  data() {
    return {
      // 筛选查询
      wScreen: {
        wLocation: null // 广告位
      },
      // 表格数据
      wTable: {
        wPage: 1,
        wLimit: 5,
        wTotal: 0,
        wList: []
      },
      // 添加/修改announcement弹框
      wAnnouncement: {
        wIsShow: false, // 是否展示
        wMediaFileList: [], // 上传文件回显
        wMediaType: null, // 媒体类型 image/video
        wForm: {
          wId: null, // id 有值代表
          wTitle: null, // 公告标题
          wContent: null, // 公告内容
          wUrl: null, // 链接地址
          wSort: 0 // 排序
        } // 表单数据
      },
      editorOptions: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [{ header: [1, 2, 3, 4, false] }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ["link", "image"],
              ["clean"]
            ]
          }
        },
        placeholder: "请输入公告内容...",
        theme: "snow"
      }
    };
  },
  mounted() {
    this.wFun_queryTableData(true);
  },
  computed: {
  },
  methods: {
    /**
     * wFun_getUploadFilePath
     * 方法-获取文件上传地址
     */
    wFun_getUploadFilePath() {
      return `${process.env.VUE_APP_URE}/file/uploadFile`;
    },
    /**
     * wFun_beforeUpload_media
     * 方法-上传前校验，支持图片/视频
     */
    wFun_beforeUpload_media(file) {
      const wImageTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
      const wVideoTypes = ["video/mp4", "video/quicktime", "video/webm"];
      const isAllowedType = wImageTypes.includes(file.type) || wVideoTypes.includes(file.type);
      if (!isAllowedType) {
        this.$message.error("仅支持上传 JPG/PNG/GIF/WEBP 图片或 MP4/MOV/WEBM 视频!");
      }
      return isAllowedType;
    },
    /**
     * wFun_getMediaTypeByMime
     * 方法-根据MIME判断媒体类型
     */
    wFun_getMediaTypeByMime(wMime) {
      if (!wMime) {
        return null;
      }
      if (wMime.indexOf("image/") === 0) {
        return "image";
      }
      if (wMime.indexOf("video/") === 0) {
        return "video";
      }
      return null;
    },
    /**
     * wFun_guessMediaTypeByUrl
     * 方法-根据URL后缀推断媒体类型（用于回显）
     */
    wFun_guessMediaTypeByUrl(wUrl) {
      if (!wUrl) {
        return null;
      }
      const wCleanUrl = wUrl.split("?")[0].toLowerCase();
      if (/\.(jpg|jpeg|png|gif|webp)$/.test(wCleanUrl)) {
        return "image";
      }
      if (/\.(mp4|mov|webm)$/.test(wCleanUrl)) {
        return "video";
      }
      return null;
    },
    /**
     * wFun_success_media
     * 方法-上传成功
     */
    wFun_success_media(response, file) {
      let { code: wCode, data: wData } = response || {};
      if (wCode == 200 && wData) {
        const wMime = (file && file.raw && file.raw.type) || (file && file.type) || "";
        this.wAnnouncement.wForm.wUrl = wData;
        this.wAnnouncement.wMediaType = this.wFun_getMediaTypeByMime(wMime) || this.wFun_guessMediaTypeByUrl(wData);
        this.wAnnouncement.wMediaFileList = [{ name: "素材文件", url: wData }];
      } else {
        this.$message.error("文件上传失败!");
      }
    },
    /**
     * wFun_error_media
     * 方法-上传失败
     */
    wFun_error_media() {
      this.$message.error("文件上传失败!");
    },
    /**
     * wFun_remove_media
     * 方法-移除上传文件
     */
    wFun_remove_media() {
      this.wAnnouncement.wForm.wUrl = null;
      this.wAnnouncement.wMediaType = null;
      this.wAnnouncement.wMediaFileList = [];
    },
    /**
     * wFun_exceed_media
     * 方法-超过上传数量限制
     */
    wFun_exceed_media() {
      this.$message.warning("最多只能上传1个文件");
    },
    /**
     * wELPageCurrentChange
     * 分页 currentPage 改变时会触发
     */
    wELPageCurrentChange(wP_cPage) {
      this.wTable.wPage = wP_cPage
      this.$nextTick(() => {
        // 获取提现审核列表数据
        this.wFun_queryTableData()
      })
    },

    /**
     * wELPageSizeChange
     * 修改分页条数
     * 分页 pageSize 改变时会触发 - 每页条数
     */
    wELPageSizeChange(wP_cPageSize) {
      // 更改当前页码数据
      this.wTable.wPage = 1
      this.wTable.wLimit = wP_cPageSize
      this.$nextTick(() => {
        // 获取提现审核列表数据
        this.wFun_queryTableData()
      })
    },

    /**
     * wFun_queryTableData
     * 方法-查询表格数据
     * @param wP_truthy 真值,true-初始值,false-加载更多
     */
    wFun_queryTableData(wP_truthy) {
      let wData = {}
      // 分页数据
      let { wPage, wLimit } = this.wTable
      let pageModel = {
        pageNo: wPage,
        pageSize: wLimit
      }
      wData['pageModel'] = pageModel
      // 请求函数
      inquiryNotice(wData)
        .then(res => {
          console.log('广告信息', res);
          // 更新数据
          this.wTable.wList = res.records;
          this.wTable.wTotal = res.total;
        })
        .catch(err => { });
    },

    /**
     * wFun_deleteAnnouncementById
     * 方法-根据id删除banner
     * @wP_id banner的id
     */
    wFun_deleteAnnouncementById(wP_id) {
      if (!wP_id) {
        this.$message.error("系统繁忙，请稍后再试！");
        return;
      }
      this.$confirm("此操作将永久删除该公告, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteOperateAnnouncementApi({
            id: wP_id
          })
            .then(res => {
              this.$message.success("删除成功!");
              this.wFun_queryTableData();
            })
            .catch(err => { });
        })
        .catch(() => { });
    },
    /**
     * wFun_openAnnouncementFrame
     * 方法-打开announcement弹框
     * @param wP_obj 打开announcement弹框信息
     */
    wFun_openAnnouncementFrame(wP_obj) {
      // 打开弹框
      this.wAnnouncement.wIsShow = true
      this.$nextTick(() => {
        // 表单初始化
        this.$refs["wAnnouncementForm"].resetFields();
        this.wAnnouncement.wMediaFileList = [];
        this.wAnnouncement.wMediaType = null;
        this.wAnnouncement.wForm.wId = null;
        if (wP_obj) {
          // 修改announcement，给表单赋值
          let [
            {
              row: {
                id: wId,
                title: wTitle,
                content: wContent,
                url: wUrl,
                sort: wSort // 是否有效 0-无效 1-有效
              }
            }
          ] = [wP_obj];
          // 更新数据
          this.wAnnouncement.wForm.wId = wId;
          this.wAnnouncement.wForm.wTitle = wTitle;
          this.wAnnouncement.wForm.wContent = wContent;
          this.wAnnouncement.wForm.wUrl = wUrl;
          this.wAnnouncement.wMediaType = this.wFun_guessMediaTypeByUrl(wUrl);
          this.wAnnouncement.wMediaFileList = wUrl ? [{ name: "素材文件", url: wUrl }] : [];
          this.wAnnouncement.wForm.wSort = wSort;
        }
      });
    },

    /**
     * wchange_location
     * 选中值发生变化时触发
     */

    /**
     * wchange_jumpType
     * 选中值发生变化时触发
     */

    /**
     * wFun_submitBannerInfo
     * 方法-提交banner信息
     */
    wFun_submitAnnouncementInfo() {
      let { wId, wTitle, wContent, wUrl, wSort } = this.wAnnouncement.wForm
      const richTextPlain = (wContent || "")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .replace(/\s+/g, "")
      if (!richTextPlain) {
        this.$message.warning("请输入公告内容")
        return
      }
      let wData = {
        id: wId,
        title: wTitle,
        content: wContent,
        url: wUrl,
        sort: Number(wSort),
      }
      console.log('wData', wData);
      // 根据id是否存在判断新增或修改
      if (wId) {
        // 修改
        // announcement id
        // wData.id = wForm.wId;

        editOperateAnnouncementApi(wData)
          .then(res => {
            this.$message.success("修改成功!");
            // 更新数据
            this.wAnnouncement.wIsShow = false;
            this.wFun_queryTableData();
          })
          .catch(err => { });
      } else {
        // 新增
        addOperateAnnouncementApi(wData)
          .then(res => {
            console.log(res);
            this.$message.success("添加成功!");
            // 更新数据
            this.wAnnouncement.wIsShow = false;
            this.wFun_queryTableData();
          })
          .catch(err => { });
      }
    }

  }
};
</script>

<style lang="less">
@import "@/assets/css/publicStyle.less";

.wMediaPreview {
  margin-top: 10px;
}

.wMediaPreviewImage {
  width: 220px;
  height: 140px;
  border: 1px solid #ebeef5;
}

.wMediaPreviewVideo {
  width: 320px;
  max-width: 100%;
  height: 180px;
  background-color: #000;
}

.wAnnouncementEditor {
  margin-bottom: 0;
}

.wAnnouncementEditor /deep/ .ql-container {
  height: 220px;
  overflow-y: auto;
}

.wAnnouncementEditor /deep/ .ql-editor {
  min-height: 180px;
}

.wUploadFormItem {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #f0f2f5;
}
</style>
